module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Theater of God’s Glory: Calvin, Creation, and the Liturgical Arts")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "CON1t"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/foreword",
      "id": "foreword"
    }
  }, [_c('i', [_vm._v("Foreword")]), _vm._v(", by John D. Witvliet")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "id": "ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations",
      "id": "abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "CON3"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction",
      "id": "introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001",
      "id": "chapter001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("Musical Instruments in Calvin")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002",
      "id": "chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The Work of the Material Creation")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "id": "chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The Work of the Material Symbols of Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "id": "chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The Twin Problem of Materiality and Mediation")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "id": "chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The Double Movement of Creation in Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "id": "chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("Calvin’s Theology of the Physical Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "id": "chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("A Trinitarian Theology of the Physical Body")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "id": "chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The “Simple” Worship of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "id": "chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space75"
  }, [_vm._v("The Trinitarian Space of Worship")])])]), _vm._v(" "), _c('p', {
    staticClass: "CON3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "id": "chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "id": "bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "CON1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "id": "index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0